import React, { Component } from 'react';

import './Auth.css';
import SignIn from './SignIn';

class AuthBridge extends Component {

  state = {}

  constructor(props) {
    super(props);

    this.state = {
      action: 'SignIn'
    };
  }

  render() {
    const { action } = this.state;
    const { props } = this;

    return (
      <div className="auth-layout-container-box">
        { action === 'SignIn' && <SignIn { ...props } /> }
        {/* { action !== 'SignIn' && <ForgotPassword /> } */}
      </div>
    )
  }
}

export default AuthBridge;